import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/auth.store";
import GameLaunchPage from "./GameLaunchPage";

const GameLaunchRoute = () => {
  const navigate = useNavigate();
  const {provider, gameId} = useParams<{provider: string; gameId: string}>();
  const status = useAuthStore(state => state.status);
  const hydrate = useAuthStore(state => state.hydrate);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  useEffect(() => {
    if (status === "unauthenticated") navigate(PATHS.authLogin, {replace: true});
  }, [status, navigate]);

  if (status !== "authenticated") {
    return <main className="min-h-screen w-full bg-[var(--color-bg)]" />;
  }

  if (!provider || !gameId) {
    return (
      <main className="min-h-screen w-full bg-[var(--color-bg)] p-8">
        <p className="text-[var(--color-text-secondary)]">Juego no encontrado.</p>
      </main>
    );
  }

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <GameLaunchPage
        provider={provider}
        gameId={gameId}
        onBack={() => navigate(PATHS.games)}
      />
    </main>
  );
};

export default GameLaunchRoute;
